export const ELEMENTS = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  X_GRID: 'xGrid',
  Y_GRID: 'yGrid',
};

export const AUTO = 'auto';

export const DEFAULT_AXIS_SPACE = 40;
